import { getOpDef } from './transform-vocab.js';
function coerceFinal(value) {
    if (value === null || value === undefined)
        return '';
    return String(value);
}
export function applyTransformChain(initialValue, chain, ctx, options = {}) {
    const trace = [];
    const errors = [];
    let current = initialValue;
    for (let i = 0; i < chain.length; i++) {
        const step = chain[i];
        const opDef = getOpDef(step.type);
        const input = current;
        if (!opDef) {
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output: input, error: `Unknown op: ${step.type}` });
            }
            if (options.withErrors) {
                errors.push({ stepIndex: i, opId: step.type, message: `Unknown op: ${step.type}` });
            }
            // Passthrough on unknown op
            continue;
        }
        try {
            const output = opDef.evaluate(input, step.config, ctx);
            current = output;
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output });
            }
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            const truncated = message.slice(0, 500);
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output: input, error: truncated });
            }
            if (options.withErrors) {
                errors.push({ stepIndex: i, opId: step.type, message: truncated });
            }
            // Passthrough on evaluator throw — lenient at export
        }
    }
    return {
        value: coerceFinal(current),
        ...(options.withTrace ? { trace } : {}),
        ...(options.withErrors ? { errors } : {}),
    };
}
export function validateTransformChain(chain, options = {}) {
    const errors = [];
    for (let i = 0; i < chain.length; i++) {
        const step = chain[i];
        const opDef = getOpDef(step.type);
        if (!opDef) {
            if (options.knownExternalOpIds?.has(step.type))
                continue;
            errors.push({ stepIndex: i, field: 'type', message: `Unknown op: ${step.type}` });
            continue;
        }
        const r = opDef.validate(step.config);
        if (!r.ok) {
            for (const e of r.errors) {
                errors.push({ stepIndex: i, field: e.field, message: e.message });
            }
        }
    }
    return errors.length === 0 ? { ok: true } : { ok: false, errors };
}
export async function applyTransformChainAsync(initialValue, chain, ctx, options = {}) {
    const trace = [];
    const errors = [];
    let current = initialValue;
    for (let i = 0; i < chain.length; i++) {
        const step = chain[i];
        const opDef = getOpDef(step.type);
        const input = current;
        if (!opDef) {
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output: input, error: `Unknown op: ${step.type}` });
            }
            if (options.withErrors) {
                errors.push({ stepIndex: i, opId: step.type, message: `Unknown op: ${step.type}` });
            }
            // Passthrough on unknown op
            continue;
        }
        try {
            const output = await Promise.resolve(opDef.evaluate(input, step.config, ctx));
            current = output;
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output });
            }
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            const truncated = message.slice(0, 500);
            if (options.withTrace) {
                trace.push({ step: i + 1, op: step.type, input, output: input, error: truncated });
            }
            if (options.withErrors) {
                errors.push({ stepIndex: i, opId: step.type, message: truncated });
            }
            // Passthrough on evaluator throw — lenient at export
        }
    }
    return {
        value: coerceFinal(current),
        ...(options.withTrace ? { trace } : {}),
        ...(options.withErrors ? { errors } : {}),
    };
}
//# sourceMappingURL=apply-transform-chain.js.map